import { render, staticRenderFns } from "./SettingsTeamDeleteUserModal.vue?vue&type=template&id=492cc343"
import script from "./SettingsTeamDeleteUserModal.vue?vue&type=script&lang=js"
export * from "./SettingsTeamDeleteUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('492cc343')) {
      api.createRecord('492cc343', component.options)
    } else {
      api.reload('492cc343', component.options)
    }
    module.hot.accept("./SettingsTeamDeleteUserModal.vue?vue&type=template&id=492cc343", function () {
      api.rerender('492cc343', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsTeamDeleteUserModal.vue"
export default component.exports